import React, { useEffect, useState } from "react";
import { BASE_URL } from "../env";
import { store } from "react-notifications-component";

const HybridExamCreating = () => {
	const [courses, setCourses] = useState([]);
	const [quizexams, setquizexams] = useState([]);
	const [codingexams, setcodingexams] = useState([]);
	const [course, setcourse] = useState("");
	const [codingExams, setcodingExams] = useState([]);
	const [quizExams, setquizExams] = useState([]);

	const [data, setdata] = useState({
		name: "",
		courseId: "",
		totalDuration: 0,
		category: "",
		genre: "",
	});

	const handleOnChange = (e) => {
		setdata((prev) => {
			return { ...prev, [e.target.name]: e.target.value };
		});
	};

	const handleOnChangearray = (e) => {
		if (e.target.name === "quizExams") {
			var p = quizExams;
			if (p.indexOf(e.target.value) === -1) p.push(e.target.value);
			else p = p.filter((s) => s !== e.target.value);

			setquizExams(p);
		} else {
			var p = codingExams;
			if (p.indexOf(e.target.value) === -1) p.push(e.target.value);
			else p = p.filter((s) => s !== e.target.value);

			setcodingExams(p);
		}
	};

	useEffect(() => {
		fetch(BASE_URL + "/getallCourse")
			.then((res) => res.json())
			.then((data) => {
				setCourses(data?.courses);
			});
		fetch(BASE_URL + "/getQuizAllEXam")
			.then((res) => res.json())
			.then((data) => {
				setquizexams(data.data);
			});
	}, []);

	useEffect(() => {
		if (course != "")
			fetch(BASE_URL + `/getExambycourse/${course}`)
				.then((res) => res.json())
				.then((data) => {
					setcodingexams(data?.message);
				});
	}, [course]);

	const handleSubmit = (e) => {
		e.preventDefault();
		const notifyPopup = (msg) => {
			store.addNotification({
				title: "Success!",
				message: msg,
				type: "success",
				background: "pink",
				insert: "bottom",
				container: "bottom-right",
				animationIn: ["animate__animated", "animate__fadeIn"],
				animationOut: ["animate__animated", "animate__fadeOut"],
				dismiss: {
					duration: 3000,
					onScreen: true,
				},
			});
		};
		fetch(BASE_URL + "/fetchingtheexam/createhybridexam", {
			method: "POST",
			headers: {
				"content-type": "application/json",
				Authorization: "Bearer " + localStorage.getItem("token"),
			},
			body: JSON.stringify({ ...data, codingExams, quizExams }),
		})
			.then((res) => res.json())
			.then((data) => {
				if (data.success) {
					notifyPopup("The exam has been created!");
				}
			})
			.catch((err) => {
				alert(err);
			});
	};

	return (
		<div className="container" style={{ marginTop: "5vw" }}>
			<form onSubmit={handleSubmit}>
				<div class="form-group mt-3">
					<label for="name">Name:</label>
					<input
						className="form-control mt-2"
						name="name"
						type="text"
						id="name"
						placeholder="Name a Hybrid Exam"
						onChange={handleOnChange}
					/>
				</div>

				<div class="form-group mt-3">
					<label for="course">Choose the course of the exam:</label>
					<select
						name="courseId"
						className="form-control"
						id="course"
						onChange={(e) => {
							setcourse(e.target.value);
							handleOnChange(e);
						}}
					>
						<option value="" selected>
							Select Course
						</option>
						{courses.map((val) => {
							return (
								<option value={val?._id}>{val?.name}</option>
							);
						})}
					</select>
				</div>

				{course != "" && (
					<div class="form-group mt-3">
						<label>Select the coding Exams:</label>
						{codingexams.length &&
							codingexams.map((val) => (
								<div class="form-check">
									<input
										class="form-check-input"
										type="checkbox"
										name="codingExams"
										value={val._id}
										id={val._id}
										onChange={handleOnChangearray}
									/>
									<label
										class="form-check-label"
										for={val._id}
									>
										{val.name}
									</label>
								</div>
							))}
					</div>
				)}

				<div class="form-group mt-3">
					<label>Select the Quiz Exams:</label>
					{quizexams.length &&
						quizexams.map((val) => (
							<div class="form-check">
								<input
									class="form-check-input"
									type="checkbox"
									name="quizExams"
									value={val._id}
									id={val._id}
									onChange={handleOnChangearray}
								/>
								<label class="form-check-label" for={val._id}>
									{val.examName}
								</label>
							</div>
						))}
				</div>

				<div class="form-group mt-3">
					<label for="time">Total Exam Duration In Minutes:</label>
					<input
						className="form-control mt-2"
						name="totalDuration"
						type="number"
						min="0"
						id="time"
						placeholder="Duration of exam"
						onChange={handleOnChange}
					/>
				</div>

				<div class="form-group mt-3">
					<label for="Category">Category:</label>
					<input
						className="form-control mt-2"
						name="category"
						type="text"
						id="Category"
						placeholder="Category of Exam"
						onChange={handleOnChange}
					/>
				</div>
				<div class="form-group mt-3">
					<label for="Category">Genre:</label>
					<input
						className="form-control mt-2"
						name="genre"
						type="text"
						id="genre"
						placeholder="Genre of Exam"
						onChange={handleOnChange}
					/>
				</div>
				<input
					type="submit"
					value="Create new Hybrid Test"
					className="btn btn-success btn-md mt-3 mb-5"
				/>
			</form>
		</div>
	);
};

export default HybridExamCreating;
